<div class="container">
  <ul class="container__list">
    <li class="container__day-item container__item--head-cell" *ngFor="let day of daysCollection">
      <div class="container__day">
        {{ day }}
      </div>
    </li>
    <ng-container *ngIf="{cells: (cells$ | async)} as streams$">
      <li *ngFor="let cell of streams$.cells; let i = index">
        <int-calendar-cell
          [cellData]="cell"
          [selectedDates]="selectedDates"
          [pluginState]="pluginState"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [markWeekends]="markWeekends"
          (onSelect)="onSelect($event)"
        ></int-calendar-cell>
      </li>
    </ng-container>
  </ul>
</div>
